import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'lfx-meeting-not-authorized',
  templateUrl: './meeting-not-authorized.component.html',
  styleUrls: ['./meeting-not-authorized.component.scss'],
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MeetingNotAuthorizedComponent {}
